import classnames from "classnames";
import React from "react";
import { L10n, L10nHtml } from "@fidget/common/i18n";
import styles from "./tileCommon.css";
import { PlanType } from "./upgradeToPlanAgent";

interface Props {
  handleClick: (plan: PlanType) => void;
  isActive: boolean;
}

export const EnterpriseTile: React.SFC<Props> = ({ isActive, handleClick }) => {
  return (
    <button
      className={classnames(styles.tile, { [styles.active]: isActive })}
      onClick={() => handleClick(PlanType.ENTERPRISE)}
    >
      <h3>
        {" "}
        <L10n id={"plan.enterprise"} />{" "}
      </h3>
      <p>
        {" "}
        <L10n id={"plan.enterprise.description"} />{" "}
      </p>
      <p className={styles.price}>
        {" "}
        <L10n id={"plan.enterprise.price"} />{" "}
      </p>
      <p className={styles.users}>
        <L10nHtml id={"plan.enterprise.20plus"} />
      </p>
    </button>
  );
};
